module.exports = __webpack_public_path__ + "media/Introduccion SmartC3.680d5a2d.mp4";